import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ISbStoryData } from '@storyblok/js';
import { StoryblokService } from 'src/app/services/storyblok.service';
import { PageDescriptionPipe } from '../../pipes/page-description.pipe';
import { PageTitlePipe } from '../../pipes/page-title.pipe';
import { BlockStyle, BlockWrapperComponent } from '../block-wrapper/block-wrapper.component';

@Component({
  selector: 'app-pinned-blog-post-link',
  standalone: true,
  templateUrl: './pinned-blog-post-link.component.html',
  styleUrls: ['./pinned-blog-post-link.component.scss'],
  imports: [CommonModule, BlockWrapperComponent, RouterLink, PageTitlePipe, PageDescriptionPipe],
})
export class PinnedBlogPostLinkComponent implements OnChanges {
  @Input() _uid: string; // just here to prevent errors
  @Input() component: string; // just here to prevent errors
  @Input() _editable: string;
  @Input() replacer?: (key: string) => string;
  @Input() style: BlockStyle[];
  @Input() relationshipFields: string;

  @Input() post: string;

  private storyblokService = inject(StoryblokService);

  pinnedPost: ISbStoryData;

  ngOnChanges() {
    const relationships = this.storyblokService.getGlobalData('relationships');
    this.pinnedPost = relationships?.find(page => page.uuid === this.post);
  }
}
